<template>
  <router-view />
</template>

<script>
  import { Auth } from 'aws-amplify'
  import { onAuthUIStateChange } from '@aws-amplify/ui-components'

  export default {
    name: 'App',
    async created () {
      // force id token to be freshed on app startup
      try {
        await Auth.currentAuthenticatedUser()
      } catch {
      }

      onAuthUIStateChange((authState, authData) => {
        if (authState === 'signedout') {
          this.$router.push('/auth')
        }
        if (authState === 'signedin') {
          this.$router.push('/')
        }
      })
    },

  }
</script>
